
<template>
<v-container>
  <v-layout row>
    <v-flex xs12>
      <v-card class="elevation-11">
        <v-card-text>
          <v-container>
            <h2 class="mb-4">Edit Greeting</h2>
            <form @submit.prevent="editGreeting()">

              <v-text-field
                name="title"
                label="Title"
                id="title"
                type="text"
                v-model="title"
                required>
              </v-text-field>

              <v-textarea
                box
                name="description"
                label="Greeting text"
                id="description"
                v-model="description"
                required>
              </v-textarea>

              <v-menu
                ref="menu"
                lazy
                :close-on-content-click="false"
                v-model="menu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                min-width="290px"
                :return-value.sync="dateStart"
                >
                <v-text-field
                  slot="activator"
                  label="Start date*"
                  id="dateStart"
                  v-model="dateStart"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dateStart" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.menu.save(dateStart)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="menu2"
                lazy
                :close-on-content-click="false"
                v-model="menu2"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                min-width="290px"
                :return-value.sync="dateEnd"
                >
                <v-text-field
                  slot="activator"
                  label="End date*"
                  v-model="dateEnd"
                  id="dateEnd"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="dateEnd" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.menu2.save(dateEnd)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-select
                label="Viewable By"
                id="vb"
                class="sel"
                menu-props="auto"
                v-model="vb"
                placeholder="Select from list"
                :items="students"
                item-text="name"
                item-value="userId"
                required
                dense>
              </v-select>

              <v-layout row>
                <v-flex xs12>
                  <v-btn small type="submit" :disabled="!formIsValid" class="secondary ml-0 mr-1">Submit</v-btn>
                  <v-btn small @click="deleteItem" class="secondary ml-0 mr-1">Delete</v-btn>
                <v-btn small @click="$router.replace('/admin')" class="ml-0">Cancel</v-btn>
                </v-flex>
              </v-layout>
            </form>

          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  mounted() {
    this.title = this.item.title
    this.vb = this.item.viewableBy
    this.item.description ? this.description = this.item.description : this.description = ""
    this.dateStart = this.item.dateStart
    this.dateEnd = this.item.dateEnd
  },
  props: ['item'],
  data() {
    return {
      menu: false,
      menu2: false,
      title: "",
      description: "",
      dateStart: "",
      dateEnd: "",
      vb: ""
    }
  },
  computed: {
    students() {
      let arrStudents = []
      let objStudent = {}

      objStudent = {
        name: 'all',
        userId: 'all'
      }
      arrStudents.push(objStudent)

      this.$store.getters.getStudents.forEach((el) => {
        if (el.isActive) {
          objStudent = {
            ...el,
            name: el.fname + ' ' + el.lname
          }
          arrStudents.push(objStudent)
        }
      })
      return arrStudents
    },
    formIsValid() {
      return this.title !== "" && this.description !== "" && this.dateStart !== "" && this.dateEnd !== "" && this.vb !== ""
    }
  },
  methods: {
    editGreeting() {
      const editedGreeting = {
        title: this.title,
        description: this.description,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        viewableBy: this.vb,
        docId: this.item.docId
      }
      this.$store.dispatch("editGreeting", editedGreeting)
    },
    deleteItem() {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$store.dispatch("deleteGreeting", this.item.docId)
        this.$store.dispatch("setType", "Greetings")
      }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}

.sel{
  font-size: 1rem;
  margin-bottom: 25px;
  margin-top: 35px;
}

.v-textarea {
  font-size: .95rem;
}
</style>